// Do NOT add "use client"
import { IGetProductFilterSectionInfoResponse } from "@faire/web-api/indigofair/data/IGetProductFilterSectionInfoResponse";
import { IQueryProductsV2WithLeanTileResponse } from "@faire/web-api/indigofair/data/IQueryProductsV2WithLeanTileResponse";

export interface SearchPageFiltersData {
  filtersResponse:
    | IQueryProductsV2WithLeanTileResponse
    | IGetProductFilterSectionInfoResponse
    | undefined;
  loading: boolean;
  isError: boolean;
  error: unknown;
}

export const INITIAL_SEARCH_PAGE_FILTERS_DATA: SearchPageFiltersData = {
  filtersResponse: undefined,
  loading: true,
  isError: false,
  error: undefined,
};
